import { layers as jiraLayers } from '@jira/platform__ui-layers';

export const contentHorizontalSpacing = 40;
/**
 * @deprecated User @jira/platform__ui-layers instead
 */
export const mobileBannerIndex = jiraLayers.mobileBanner;
/**
 * @deprecated User @jira/platform__ui-layers instead
 */
export const layers = jiraLayers;

export const layout = {
	issueIconSize: 16,
} as const;
